// extracted by mini-css-extract-plugin
export default {"container":"TableMenu_container__SL20u","filter":"TableMenu_filter__gTD9Z","filter__image":"TableMenu_filter__image__N7Of1","disabled":"TableMenu_disabled__NpOhd"};